import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { BidHistory } from "./BidHistory";
import React from "react";
import theme from "../../../theme";
import { useTranslation } from "react-i18next";

const BidHistoryPopup = ({
  auctionHistory=[],
  selectedCar = {},
  isLoading=false,
  handleClose
}) => {
  
  const { t } = useTranslation("myGarage");

  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: '80%', md: '60%', lg: '28rem' },
        bgcolor: 'background.paper',
        borderRadius: '0.5rem',
        boxShadow: '0rem 0.25rem 0.75rem rgba(0, 0, 0, 0.2)',
        p: '2rem',
        outline: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        maxHeight: '90vh',
        overflowY: 'auto',
      }}
    >
      {/* Header Section */}
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          id="bid-history-modal-title"
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 600,
            fontSize: '1.5rem',
            color: 'text.primary',
            mb: '0.5rem',
          }}
        >
          {t("Bid History")}
        </Typography>
        
        {auctionHistory?.length > 0 ? (
          <Box
            sx={{
              display: "flex",
              border: "1px solid",
              borderColor: "border.main",
              p: "4px",
              borderRadius: "0.5rem",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              slotProps={{
                indicator: { style: { display: "none" } },
                tabScrollButton: {
                  sx: {
                    color: theme.palette.primary.main,
                    '&[aria-disabled="true"]': {
                      display: "none",
                    },
                  },
                },
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                "& .MuiTabs-flexContainer": {
                  height: "100%",
                },
                "& .MuiTab-root": {
                  color: "text.primary",
                  padding: "0.75rem 1.5rem",
                  textTransform: "none",
                  fontWeight: 500,
                  "&.Mui-selected": {
                    borderRadius: 2,
                    backgroundColor: "primary.main",
                    color: "white",
                  },
                },
              }}
            >
              {auctionHistory?.map((auction, auctionIdx) => {
                return (
                  <Tab 
                    key={auctionIdx} 
                    label={`${t("Auction")} #${auctionIdx + 1}`} 
                  />
                )
              })}
            </Tabs>
          </Box>
        ) : null}
      </Box>

      <BidHistory 
        selectedCar={selectedCar}
        bids={auctionHistory?.[tabValue]?.bids}
        isLoading={isLoading}
        showTitle={false}
      />

      {/* Close Button */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: '1rem' }}>
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{
            bgcolor: 'primary.main',
            color: 'text.secondary',
            fontSize: '1rem',
            fontWeight: 500,
            borderRadius: '0.5rem',
            px: '2rem',
            py: '0.75rem',
            textTransform: 'none',
            '&:hover': {
              bgcolor: 'primary.gradient1',
            },
          }}
        >
          {t("Close")}
        </Button>
      </Box>
    </Box>
  )
}

export { BidHistoryPopup };